import { DeepPartialObject } from "@costar-gen/centralnews-node-client";
import { itemId, getPage } from "@costar-search-x/core";
import { isCriteriaValid } from "./search-helper";
import {
  DirectoryLocationCountRequest,
  DirectoryLocationCountResponse,
} from "@/app/api/directory/location/count/route";
import { DirectoryListResponse } from "@/app/api/directory/location/list/route";
import {
  DirectorySearchRequest,
  DirectorySearchResponse,
} from "@/app/api/directory/location/search/route";
import { DirectorySearchWithListResponse } from "@/app/api/directory/location/search-with-list/route";

const getCounts = async (criteria: {
  criteria: DeepPartialObject<DirectoryLocationCountRequest>;
}) => {
  if (isCriteriaValid(criteria.criteria)) {
    const res = await fetch("/api/directory/location/count", {
      method: "POST",
      body: JSON.stringify(criteria.criteria),
    });
    const d: DirectoryLocationCountResponse = await res.json();
    return d?.data?.count;
  }
  return 0;
};

const getSearch = async (criteria: {
  criteria: DeepPartialObject<DirectorySearchRequest>;
  recordSetSize?: number;
  recordSetNumber?: number;
}) => {
  const res = await fetch("/api/directory/location/search", {
    method: "POST",
    body: JSON.stringify({
      pgSize: criteria.recordSetSize,
      pgNum: criteria.recordSetNumber,
      ...criteria.criteria,
    }),
  });
  const d: DirectorySearchResponse = await res.json();
  return d.data?.keys?.map((k) => ({ [itemId]: k })) ?? []; //should be undefined?
};

const getList = async (
  searchResult: { [itemId]: string }[],
  pageNumber: number,
  pageSize: number
) => {
  const page = getPage(searchResult, pageNumber, pageSize);
  const keys = page?.data?.map((p: { [itemId]: string }) => p?.[itemId]);

  const res = await fetch("/api/directory/location/list", {
    method: "POST",
    body: JSON.stringify({ keys }),
    headers: {
      culture: "fr-FR",
    },
  });
  const d: DirectoryListResponse = await res.json();
  const data = d?.data?.placards;

  return { data, pageNumber };
};

const getSearchWithList = async (
  criteria: {
    criteria: DeepPartialObject<DirectorySearchRequest>;
    recordSetSize?: number;
    recordSetNumber?: number;
  },
  pageNumber: number,
  pageSize: number
) => {
  if (isCriteriaValid(criteria.criteria)) {
    const res = await fetch("/api/directory/location/search-with-list", {
      method: "POST",
      body: JSON.stringify({
        criteria: criteria.criteria,
        pageNumber,
        pageSize,
        recordSetSize: criteria?.recordSetSize,
        recordSetNumber: criteria?.recordSetNumber,
      }),
      headers: {
        culture: "fr-FR",
      },
    });
    const data: DirectorySearchWithListResponse = await res.json();

    return { data: data?.data ?? [], result: data?.result ?? [], pageNumber };
  }
  return { data: [], result: [], pageNumber: 1 };
};

export { getCounts, getSearch, getList, getSearchWithList };
